export var validateEmail = function (value) {
    var isValid = (value === null || value === void 0 ? void 0 : value.split('').filter(function (x) { return x === '@'; }).length) === 1 && !(value === null || value === void 0 ? void 0 : value.match(/[<>,;()|:\\/]/));
    var message = value ? ((value === null || value === void 0 ? void 0 : value.toString()) + " is not a valid email address.") : ('Please provide a valid email address.');
    return isValid || {
        isValid: isValid,
        message: message
    };
};
